import React from "react";

import Carocel from "../Carocel/Carocel";
import Footer from "../Footer/Footer";
import Services from "../Services/Services";

const Home = () => {
  return (
    <div>
      <Carocel />
      <Services></Services>
      <Footer></Footer>
    </div>
  );
};

export default Home;
